import React, { useMemo } from "react";
import Select from "../../form/select/Select";

const Account = ({
  p_account_info,
  values,
  errors,
  edit,
  gl_accounts,
  setFieldValue,
}) => {
  return (
    <>
      <h5 className='text-primary-1 mt-2'>ACCOUNT GL</h5>
      {!edit ? (
        <div className='row'>
          {p_account_info?.income_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Income GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.income_account?.filter(
                    (income) =>
                      income.id === parseInt(p_account_info?.income_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.expense_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Expense GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.expense_account?.filter(
                    (expense) =>
                      expense.id === parseInt(p_account_info?.expense_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.asset_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Asset GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.asset_account?.filter(
                    (asset) => asset.id === parseInt(p_account_info?.asset_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.libility_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Policy Portfolio
              </label>
              <p>
                {
                  gl_accounts?.accounts?.liability_account?.filter(
                    (liability) =>
                      liability.id === parseInt(p_account_info?.libility_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.over_payment_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Overpayment
              </label>
              <p>
                {
                  gl_accounts?.accounts?.liability_account?.filter(
                    (liability) =>
                      liability.id === parseInt(p_account_info?.over_payment_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.provision_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Provision GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.provision_account?.filter(
                    (provision) =>
                      provision.id === parseInt(p_account_info?.provision_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.tax_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Tax GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.tax_account?.filter(
                    (tax) => tax.id === parseInt(p_account_info?.tax_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
        </div>
      ) : (
        <div className='col-md-'>
          <div className='mb-3'>
            <div>
              {errors?.gl && <p className='alert alert-danger'>{errors?.gl}</p>}
            </div>
            <div className='d-flex gap-2  mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Income GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='income_gl'
                  data={gl_accounts?.accounts?.income_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.income_gl}
                  //   value={values.income_gl || p_account_info?.income_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("income_gl", selectedOption?.value)
                  }
                />
                {errors?.income_gl && (
                  <p className='mb-0 text-danger'>{errors?.income_gl + "*"}</p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Commission
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='expense_gl'
                  data={gl_accounts?.accounts?.expense_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.expense_gl}
                  value={values.expense_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("expense_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Asset GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='asset_gl'
                  data={gl_accounts?.accounts?.asset_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  value={values.asset_gl}
                  defaultValue={p_account_info?.asset_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("asset_gl", selectedOption?.value)
                  }
                />
                {errors?.asset_gl && (
                  <p className='mb-0 text-danger'>{errors?.asset_gl + "*"}</p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Policy Portfolio
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='libility_gl'
                  data={gl_accounts?.accounts?.liability_account?.map(
                    (item) => ({
                      label: item?.account_name,
                      value: item?.id,
                    })
                  )}
                  defaultValue={p_account_info?.libility_gl}
                  value={values.libility_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("libility_gl", selectedOption?.value)
                  }
                />
                {errors?.libility_gl && (
                  <p className='mb-0 text-danger'>
                    {errors?.libility_gl + "*"}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Overpayment
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='over_payment_gl'
                  data={gl_accounts?.accounts?.liability_account?.map(
                    (item) => ({
                      label: item?.account_name,
                      value: item?.id,
                    })
                  )}
                  defaultValue={p_account_info?.over_payment_gl}
                  value={values.over_payment_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("over_payment_gl", selectedOption?.value)
                  }
                />
                {errors?.over_payment_gl && (
                  <p className='mb-0 text-danger'>
                    {errors?.over_payment_gl + "*"}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Provision GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='provision_gl'
                  data={gl_accounts?.accounts?.provision_account?.map(
                    (item) => ({
                      label: item?.account_name,
                      value: item?.id,
                    })
                  )}
                  defaultValue={p_account_info?.provision_gl}
                  value={values.provision_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("provision_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Tax GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='tax_gl'
                  data={gl_accounts?.accounts?.tax_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.tax_gl}
                  value={values.tax_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("tax_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Account;
